import { closestCenter, DndContext, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { restrictToVerticalAxis, restrictToWindowEdges } from "@dnd-kit/modifiers";
import { arrayMove, SortableContext, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import cn from "classnames";
import { DefaultTemplate } from "components/modal/templates";
import { customFieldKinds, entityTypes } from "helpers/enums";
import { enumLabel } from "helpers/system";
import React, { useEffect, useState } from "react";
import { editCustomFieldsOrder, getCustomFieldsOrder } from "sources/admin";

const SortableItem = ({ id, index, displayName, kind, propertyName, type }) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <tr ref={setNodeRef} style={style} {...attributes} {...listeners} className="sortable__item">
            <td className="align-middle">
                <i className="icon-uEAB4-arrows-up-down text-muted sortable__item--icon" />
            </td>
            <td>{index + 1}</td>
            <td>{displayName}</td>
            <td>{enumLabel(customFieldKinds, kind)}</td>
            <td>{enumLabel(entityTypes, type)}</td>
            <td>{propertyName}</td>
        </tr>
    );
};

const SortableList = ({ organizationId, close }) => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const sensors = useSensors(useSensor(PointerSensor));

    useEffect(() => {
        getCustomFieldsOrder(organizationId).then((items) => {
            setItems(items);
            setLoading(false);
        });
    }, []);

    const handleDragEnd = (event) => {
        const { active, over } = event;

        if (active.id !== over.id) {
            setItems((items) => {
                const oldIndex = items.findIndex((item) => item.id === active.id);
                const newIndex = items.findIndex((item) => item.id === over.id);

                return arrayMove(items, oldIndex, newIndex);
            });
        }
    };

    const saveFieldsOrder = () => {
        setLoading(true);
        const models = [...items].map((item, i) => ({ ...item, order: i }));
        editCustomFieldsOrder({ organizationId, models }).then(() => {
            setLoading(false);
            close();
        });
    };

    return (
        <table className={cn("table table-sm table-hover mb-0", { loading })}>
            <thead>
                <tr>
                    <th />
                    <th>#</th>
                    <th>Название</th>
                    <th>Тип поля</th>
                    <th>Тип объекта</th>
                    <th>Ключ</th>
                </tr>
            </thead>
            <tbody>
                <DndContext
                    sensors={sensors}
                    collisionDetection={closestCenter}
                    onDragEnd={handleDragEnd}
                    modifiers={[restrictToVerticalAxis, restrictToWindowEdges]}
                >
                    <SortableContext items={items} strategy={verticalListSortingStrategy} disabled={loading}>
                        {items.map((item, i) => (
                            <SortableItem key={item.id} {...item} index={i} />
                        ))}
                    </SortableContext>
                </DndContext>
            </tbody>
            <tfoot>
                <tr>
                    <td colSpan={6} className="text-right">
                        <div className="btn btn-brand btn-sm" onClick={saveFieldsOrder}>
                            Сохранить
                        </div>
                    </td>
                </tr>
            </tfoot>
        </table>
    );
};

class BidFieldsOrderForm extends DefaultTemplate {
    renderBody = () => <SortableList organizationId={this.props.organizationId} close={this.close} />;
}

export default BidFieldsOrderForm;
